import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getTeamMembers, inviteMember, removeMember } from '../lib/team-api'
import { workspacesQueryOptions } from './useWorkspaces'

export function teamMembersQueryOptions(workspaceId: string) {
  return queryOptions({
    queryKey: ['team', workspaceId] as const,
    queryFn: () => getTeamMembers(workspaceId),
  })
}

export function useTeamMembers(workspaceId: string) {
  return useQuery(teamMembersQueryOptions(workspaceId))
}

export function useInviteMember(workspaceId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: { email: string; role: 'admin' | 'editor' }) =>
      inviteMember(workspaceId, payload),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({ queryKey: teamMembersQueryOptions(workspaceId).queryKey })
        queryClient.invalidateQueries({ queryKey: workspacesQueryOptions().queryKey })
      }
    },
  })
}

export function useRemoveMember(workspaceId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (userId: string) => removeMember(workspaceId, userId),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({ queryKey: teamMembersQueryOptions(workspaceId).queryKey })
        queryClient.invalidateQueries({ queryKey: workspacesQueryOptions().queryKey })
      }
    },
  })
}
